import { render, staticRenderFns } from "./paint.vue?vue&type=template&id=40ed6484&scoped=true&"
import script from "./paint.vue?vue&type=script&lang=ts&"
export * from "./paint.vue?vue&type=script&lang=ts&"
import style0 from "./paint.vue?vue&type=style&index=0&id=40ed6484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ed6484",
  null
  
)

export default component.exports